export function formatErrorText(error: Error & { digest?: string }): string {
  const lines = [`Error: ${error.message}`];
  if (error.digest) {
    lines.push(`Digest: ${error.digest}`);
  }
  if (typeof window !== "undefined") {
    lines.push(`URL: ${window.location.href}`);
  }
  if (error.stack) {
    lines.push(`Stack:\n${error.stack}`);
  }
  return lines.join("\n");
}
